import { Box } from '@mui/material';
import MediaEntetiesTable from '../../../common/MediaEntitiesTable';

const SocialGrowthTable = () => {
	return (
		<Box className="w-full">
			<MediaEntetiesTable media_id={9} />
		</Box>
	);
};

export default SocialGrowthTable;
